var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('flex',{attrs:{"items":_vm.items,"academic-main-id":_vm.academicMainId,"academic-main-type-id":_vm.academicMainTypeId,"direction":"column"}})
}
var staticRenderFns = []

export { render, staticRenderFns }